/** @file Contains the component rendering the CG Logo. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import wideNormalInv from '../../static/img/codegrade-inv.svg';
import wideNormal from '../../static/img/codegrade.svg';
import logoNormalInv from '../../static/img/logo-inv.svg';
import logoNormal from '../../static/img/logo.svg';
const images = {
    logo: {
        image: logoNormal,
        inv: { image: logoNormalInv },
    },
    wide: {
        image: wideNormal,
        inv: { image: wideNormalInv },
    },
};
export default tsx.component({
    name: 'cg-logo',
    functional: true,
    props: {
        inverted: p(Boolean).required,
        small: p(Boolean).default(false),
    },
    /**
     * Renders the component.
     *
     * @param h Vue's Hyperscript function.
     * @param ctx Render context.
     * @returns The computed VNode for the component.
     */
    render(h, ctx) {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        function getLogoSrc() {
            let lookup;
            if (ctx.props.small) {
                lookup = images.logo;
            }
            else {
                lookup = images.wide;
            }
            if (ctx.props.inverted) {
                return lookup.inv.image;
            }
            else {
                return lookup.image;
            }
        }
        return h('img', {
            attrs: {
                src: getLogoSrc(),
                alt: 'CodeGrade',
                ...ctx.data.attrs,
            },
            class: [ctx.data.class, ctx.data.staticClass, 'cg-logo'],
            style: [ctx.data.style, ctx.data.staticStyle],
        });
    },
});
